import { Box, Button, Typography } from '@mui/material';
import Image from 'next/image';
import Link from 'next/link';
import { ICustomizedContentCardListProps } from './interface';

export const withEmptyContent =
  (Component: React.ComponentType<ICustomizedContentCardListProps>) =>
  (props: ICustomizedContentCardListProps) => {
    const { contents, loading } = props;

    if (!loading && !contents?.length)
      return (
        <Box
          display="flex"
          alignItems="center"
          gap={5}
          sx={{
            flexDirection: {
              xs: 'column',
              sm: 'row',
            },
          }}
        >
          <Image
            src="/img/empty-content.svg"
            alt="Nenhum conteúdo encontrado"
            width={250}
            height={250}
          />

          <Box textAlign="center">
            <Typography align="center" variant="h5" sx={{ marginBottom: 1 }}>
              Nenhum conteúdo foi encontrado.
            </Typography>
            <Button
              href="/"
              component="a"
              LinkComponent={Link}
              variant="outlined"
              color="primary"
              size="small"
            >
              Voltar para o Início
            </Button>
          </Box>
        </Box>
      );

    return <Component {...props} />;
  };
